export default class User {
  constructor(data = {}) {
    this.user_id = data.user_id || null;
    this.name = data.name || null;
    this.age = data.age || null;
    this.image_url = data.image_url || null;
    this.image_preview = data.image_preview || null;
    this.specifics = data.specifics || null;

    // ------------------------------------------------------------
    // 🔐 AUTH / LOGIN
    // ------------------------------------------------------------

    this.email = data.email || null;
    this.auth_email = data.auth_email || null;
    this.provider = data.provider ?? null;
    this.phone_number = data.phone_number || null;

    this.about_self = data.about_self || null;
    this.advanced = data.advanced || null;
    this.certificates = data.certificates || null;
    this.rating = data.rating || null;
    this.tags = data.tags || null;
    this.is_region_vacancy = data.is_region_vacancy || null;
    this.free = data.free || false;
    this.is_consultant = data.is_consultant || false;
    this.job_status = data.job_status ?? 1;
    this.fcm_token = data.fcm_token || null;
    this.locale = data.locale || null;
    this.is_employer = data.is_employer ?? false;


    // ------------------------------------------------------------
    // 📱 DEVICE / ACTIVITY
    // ------------------------------------------------------------

    this.user_agent = data.user_agent || null;
    this.last_seen = data.last_seen || null;

    this.is_remote = data.is_remote || false;
    this.is_phone_number_hidden = data.is_phone_number_hidden || false;
    this.currency = data.currency || null;
    this.salary = data.salary || null;

    this.interaction_companies = data.interaction_companies || [];

    this.hashtags = Array.isArray(data.hashtags)
      ? data.hashtags.map(h => (
          typeof h === "string"
            ? h
            : h.name
        ))
      : [];

    this.city = data.city || {};
    this.is_friend = data.is_friend || false;
    this.career = data.career || [];
    this.education = data.education || [];
    this.languages = data.languages || [];
    this.cover_url = data.cover_url || null;

    // ------------------------------------------------------------
    // 🏢 ТЕКУЩАЯ КОМПАНИЯ (старый режим)
    // ------------------------------------------------------------

    this.current_company = data.current_company || null;

    // ------------------------------------------------------------
    // 🆕 MULTI COMPANY SUPPORT
    // ------------------------------------------------------------

    this.company_ids = Array.isArray(data.company_ids)
      ? data.company_ids
      : [];

    this.companies = Array.isArray(data.companies)
      ? data.companies
      : [];

    // ------------------------------------------------------------
    // 🌐 СОЦИАЛЬНЫЕ СЕТИ
    // ------------------------------------------------------------

    this.social = {
      facebookId: data.social?.facebookId || "",
      facebookEnabled: data.social?.facebookEnabled || false,

      instagramId: data.social?.instagramId || "",
      instagramEnabled: data.social?.instagramEnabled || false,

      twitterId: data.social?.twitterId || "",
      twitterEnabled: data.social?.twitterEnabled || false,

      youtubeId: data.social?.youtubeId || "",
      youtubeEnabled: data.social?.youtubeEnabled || false,

      linkedinId: data.social?.linkedinId || "",
      linkedinEnabled: data.social?.linkedinEnabled || false,

      telegramId: data.social?.telegramId || "",
      telegramEnabled: data.social?.telegramEnabled || false,
    };

    // ------------------------------------------------------------
    // 💼 РАБОЧИЕ ПРОФИЛИ
    // ------------------------------------------------------------

    this.working_profiles = {
      behanceID: data.working_profiles?.behanceID || "",
      behanceEnabled: data.working_profiles?.behanceEnabled || false,

      dribbbleID: data.working_profiles?.dribbbleID || "",
      dribbbleEnabled: data.working_profiles?.dribbbleEnabled || false,

      githubID: data.working_profiles?.githubID || "",
      githubEnabled: data.working_profiles?.githubEnabled || false,
    };
  }
}